module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"debug_actions":"Debug Actions"}}')
  delete Component.options._Ctor
}
